import { Note } from '@domain/purchasing/models/Notes';
import { CreateNoteDTO, NoteDTO, UpdateNoteDTO } from '../dto/NotesDTO';
import { PurchaseOrderMapper } from './PurchaseOrderMapper';
import { PurchaseOrderItemMapper } from './PurchaseOrderItemMapper';
  
export class NotesMapper {
  static toModel(dto: NoteDTO): Note {
    return {
      id: dto.id,
      content: dto.content,
      purchaseOrder:  PurchaseOrderMapper.toModel(dto.purchaseOrder),
      purchaseOrderItem: dto.purchaseOrderItem ? PurchaseOrderItemMapper.toModel(dto.purchaseOrderItem) : undefined,
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt)
    };
  }

  static toCreateDTO(note: Omit<Note, 'id' | 'createdAt' | 'updatedAt'>): CreateNoteDTO {
    return {
      content: note.content,
      purchaseOrderId: note.purchaseOrder?.id || '',
      purchaseOrderItemId: note.purchaseOrderItem?.id || null
    };
  }

  static toUpdateDTO(note: Omit<Note, 'id' | 'createdAt' | 'updatedAt'>): UpdateNoteDTO {
    return {
      content: note.content,
      purchaseOrderId: note.purchaseOrder?.id,
      purchaseOrderItemId: note.purchaseOrderItem?.id
    };
  }
}
